
import { mapState, mapGetters } from 'vuex'
import { analytics, db } from '~/plugins/firebase'
import {
  addDoc,
  getDocs,
  query,
  collection,
  getDoc,
  where,
  doc,
  increment,
} from 'firebase/firestore'
import { logEvent } from 'firebase/analytics'
import { updateFirestoreDoc } from '../../api'

export default {
  props: { graduate: Object, schools: Array, likes: Array },
  data: () => ({
    tab: 'null',
    dialog: false,
    played: false,
    viewed: false,
  }),
  mounted() {
    updateFirestoreDoc('grads', this.graduate.id, { app: increment(1) })
  },
  computed: {
    ...mapState({
      authUser: (state) => state.authUser,
    }),
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
      emailVerified: 'emailVerified',
      isAdmin: 'isAdmin',
      isGraduate: 'isGraduate',
      isIndustry: 'isIndustry',
    }),
    multipleVideos() {
      return this.graduate?.videos?.length > 1 ? true : false
    },
    school() {
      return this.schools.find((o) => o.id == this.graduate.school)
    },
    displayLabelNew() {
      if (this.graduate.createdAt) {
        const createdAt = new Date(this.graduate.createdAt.seconds * 1000)
        let currentDate = new Date().getTime()
        const fortnightDate = Math.abs(new Date(createdAt).getTime() + 12096e5)
        return currentDate < fortnightDate
      } else {
        return false
      }
    },
    sortedRegions() {
      if (this.graduate.availableRegions)
        return this.graduate.availableRegions.sort()
    },
  },
  methods: {
    playVideo() {
      this.played = true
      logEvent(analytics, 'select_content', {
        content_type: 'video',
        item_id: this.graduate.id,
      })
    },
    viewCV() {
      this.viewed = true
      logEvent(analytics, 'select_content', {
        content_type: 'cv',
        item_id: this.graduate.id,
      })
    },
    toggleLike(item) {
      this.$emit('toggleLike', item)
    },
    async getUserData() {
      const docSnap = await getDoc(doc(db, 'users', this.authUser.uid))
      return docSnap.data()
    },
    async startChat(graduateUid) {
      const uids = [this.authUser.uid, graduateUid]
      const orderedUids = uids.sort()
      //check if existing chat
      try {
        const q = query(
          collection(db, 'chats'),
          where('users', '==', orderedUids)
        )
        const docSnap = await getDocs(q)
        if (docSnap.empty) {
          const { photoURL, company } = await this.getUserData()
          const doc = {
            count: 0,
            lastMessage: '',
            messages: [],
            users: orderedUids,
            user: [
              // Current logged in user
              {
                uid: this.authUser.uid,
                name: this.authUser.displayName,
                avatar: photoURL,
                company: company,
              },
              // Graduate user
              {
                uid: graduateUid,
                name: `${this.graduate.firstName} ${this.graduate.lastName}`,
                avatar: this.graduate.img,
              },
            ],
          }
          // if no chat create document
          await addDoc(db, 'chats', doc)
        }
        //redirect to chat page
        this.$router.push('/chat/')
      } catch (error) {
        // console.log(error)
      }
    },
  },
}
